import React from 'react';
import { Row, Col, Button, Dropdown, Menu } from 'antd';
import { GlobalOutlined, MenuOutlined } from '@ant-design/icons';
import resources from '../resources';
import StoreManager from '../appdata';
import languages from '../appdata/languages';

class DesktopMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false, // 🆕 thêm state theo dõi scroll
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const isScrolled = window.scrollY > 0; // nếu kéo xuống bất kỳ pixel nào
    this.setState({ scrolled: isScrolled });
  };

  handleLanguageChange = ({ key }) => {
    localStorage.setItem('lang', key); // 💾 lưu vào local
    StoreManager.appState.thisApp.setState({ currentLanguage: key });
  };

  render() {
    const { isMobile, showDrawer } = this.props;
    const { scrolled } = this.state;

    const backgroundColor = scrolled
      ? 'rgba(255,255,255,1)' // scroll xuống -> trắng mờ
      : 'rgba(255,255,255,0)';  // ban đầu -> trong suốt

    const languageMenu = (
      <Menu onClick={this.handleLanguageChange}>
        <Menu.Item key="vi">Tiếng Việt</Menu.Item>
        <Menu.Item key="en">English</Menu.Item>
      </Menu>
    );

    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].HeaderContent;

    return (
      <div
        style={{
          width: '100%',
          margin: '0 auto',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 999,
          backgroundColor: backgroundColor,
          paddingBottom: 12,
          transition: 'background-color 0.3s ease', // chuyển mượt mà
        }}
      >
        <div style={{ maxWidth: 1040, margin: '0 auto', paddingLeft: isMobile ? 20 : 0, paddingRight: isMobile ? 20 : 0 }}>
          <Row justify="space-between" align="middle" style={{ paddingTop: 20, position: 'relative', zIndex: 2 }}>
            <Col>
              <img 
              onClick={() => {
                StoreManager.appState.thisApp.setState({
                  currentPage: 'HomeScreen',
                  subPageContent: '',
                });
                window.history.pushState({}, '', '/'); // 🆕 cập nhật URL về /
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
               src={resources.images.vnglogo} alt="VNG logo" style={{ height: 30, cursor: 'pointer'  }} />
            </Col>
            <Col>
              {!isMobile && (
                <Button
                shape="round"
                  type="primary"
                  style={{ backgroundColor: '#ff5c00', border: 'none', marginRight: 20 }}
                  onClick={() => {
                    const fileName = lg == 'vi' ? 'VNGAR_VI.pdf' : 'VNGAR_EN.pdf';
                    const link = document.createElement('a');
                    link.href = `/download/${fileName}`;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  {lang.titleButton}
                </Button>
              )}
              <Dropdown overlay={languageMenu} placement="bottomRight" trigger={['click']}>
                {/* <GlobalOutlined style={{ fontSize: 20, marginRight: 20, cursor: 'pointer' }} /> */}
                <img
                  src={resources.images.languageIcon}
                  alt="language"
                  onClick={(e) => e.stopPropagation()} // để Dropdown hoạt động
                  style={{ height: 24, marginRight: 24, cursor: 'pointer',
                    verticalAlign: 'middle' // ✅ căn giữa theo chiều dọc
                   }}
                />
              </Dropdown>
              {isMobile && (
                <MenuOutlined style={{ fontSize: 20 }} onClick={showDrawer} />
              )}
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default DesktopMenu;
